// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout';
var maintainRouter = {
  path: '/weipage',
  component: Layout,
  redirect: '/weipage/list',
  name: 'weipage',
  meta: {
    title: '微页面',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/weipage/list');
    },
    name: 'weipage',
    meta: {
      title: '微页面',
      noCache: true
    }
  }, {
    path: 'create',
    component: function component() {
      return import('@/views/weipage/list/createWeipage');
    },
    name: 'createWeipage',
    meta: {
      title: '创建微页面',
      noCache: true
    }
  }]
};
export default maintainRouter;